// extracted by mini-css-extract-plugin
module.exports = {"allfaq":"_1K2zu"};